module.exports = __webpack_public_path__ + "img/account-dollar.3521786f.svg";